import { mutate } from '../../core/createApolloClient/createApolloClient.client';
import { getp } from '../../helpers/getProp';
import gql from 'graphql-tag';

export const sendMessageQ = gql`
  mutation sendMessage(
    $threadId: Int!
    $content: String
    $eventName: String
    $startDate: String
    $endDate: String
  ) {
    sendMessage(
      threadId: $threadId
      content: $content
      eventName: $eventName
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      sentBy
      content
      eventName
      startDate
      endDate
      createdAt
    }
  }
`;

let lastMessage = '';
export default async function(variables) {
  //   console.log('sendMessageQL.js - pre ', variables, sendMessageQ);
  if (
    variables.eventName === 'message' &&
    (lastMessage === variables.content || variables.content === '')
  ) {
    return {
      error: 'empty or duplicate message',
    };
  }

  lastMessage = variables.content;
  const res = await mutate(sendMessageQ, variables).catch(err => {
    console.log('sendMessageQFn.js - threw ' + err);
    return {
      error: 'sendMessageQFn.js - message threw: ' + err,
    };
  });
  console.log('sendMessageQFn.js - message sent', res);
  if (res && res.data) {
    //Send Email :: See sendMessageAction.js
    //   Need to move email building to the server
    //   Do not do this client side
    return res.data.sendMessage;
  }
  return {
    error: 'sendMessageQL.js - message failed to send: ' + res.message,
  };
}



// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/sendMessageQFn.js